define('home/templates/channelBanner',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"banner__wrapper\" data-role=\"banner\">\n<a href=\"/home/channel/"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.slug : depth0), depth0))
    + "/\" class=\"link-inverted\">\n<div class=\"channel-cover section-contained align align--middle\">\n"
    + ((stack1 = container.invokePartial(partials.channelCoverLogo,depth0,{"name":"channelCoverLogo","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</a>\n</div>\n";
},"usePartial":true,"useData":true})

});
